import { useTheme } from '@chakra-ui/react'
import { Settings } from 'features/Settings/domain/Settings.domain'

export const useThemeType = (): Settings.Theme => {
  const theme = useTheme()
  return theme.id as Settings.Theme
}
